export default __webpack_public_path__ + "static/logo-dd4d191036840e7cdde30cac4367d8a0.png";